import React, { useEffect, useState } from "react";
import jci from "../../../images/jci.png";
import caseStudy from "../../../images/caseStudy.png";
import case_under from "../../../images/case_under.png";
import { IMAGE_URL } from "../../../constants";
import { thirdparty } from "../../..";
import { isMobile } from "react-device-detect";
const CaseStudy = () => {
  const [fatchdata, setFatchdata] = useState([]);
  useEffect(() => {
    fetchData(); // Initial data fetch
  }, []);
  const fetchData = async () => {
    try {
      const response = await thirdparty.get("/settings/1"); // Update the API endpoint

      if (response.status === 200) {
        setFatchdata(response.data);
        // setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };
  return (
    <div>
      <section
        style={{ backgroundColor: "#F7F5EF", paddingBottom: "4rem" }}
        className={`news-events pb-5 ${isMobile ? "pt-0" : ""}`}
        id="hr-lines"
      >
        <div
          className="container jci"
          style={{
            backgroundImage: `url(${caseStudy})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            width: "100%",
            borderRadius: "10px",
            opacity: 0.9,
            height: isMobile ? "265px" : "450px",
          }}
        >
          <div
            className="d-flex flex-column justify-content-around align-items-center"
            style={{ height: "100%" }}
          >
            <h3
              className="text-left "
              style={{
                color: "#AF9763",
                fontSize: isMobile ? "18px" : "28px",
                fontWeight: "500",
                display: "flex",
                flexDirection: "column",
                // marginTop: "3rem",
              }}
            >
              Case Study
              {/* <img
                src={case_under}
                style={{ width: "100%", maxWidth: "79px" }}
                alt=""
              /> */}
            </h3>

            <a
              className="text-light"
              href="/pages/case-study"
              style={{ textDecoration: "none" }}
            >
              <button
                style={{
                  fontSize: "16px",
                  width: "118px",
                  height: "43px",
                  backgroundColor: "#F58220",
                  color: "#fff",
                  textTransform: "capitalize",
                  border: "none",
                  borderRadius: "6px",
                  fontWeight: 500,
                  // marginBottom: "3rem",
                }}
              >
                View details
              </button>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CaseStudy;



// WEBPACK FOOTER //
// ./src/component/frontend/commonsections/CaseStudy.js